import { forwardRef } from "react";

const Input = forwardRef((props, ref) => {
	
	return (
		<div className={`${props.className} form-control`}>
			<label className="block">
				<span className="block text-lg font-medium text-slate-700">{ props.label }</span>
				<input
					type="text"	
					ref={ref}		
					className="mt-1 block w-full px-3 py-5 bg-white border border-slate-300 rounded-md text-lg shadow-sm placeholder-slate-400
						focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
						disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
						invalid:border-pink-500 invalid:text-pink-600
						focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
				/>
			</label>
		</div>
	);
});

export default Input;
